import React from 'react';
import Slider from 'react-slick';
//import s from '../../layouts/desktop/EtimesListing.scss';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';

const BannerView = ({ item, s }) => {
  const settings = {
    dots: false,
    slidesToShow: item.slidesToShow,
    slidesToScroll: item.slidesToScroll,
    infinite: item?.infinite,
    centerMode: item?.centerMode,
    className: item?.centerMode ? 'center' : '',
  };
  return (
    <div
      className={
        item.classNames &&
        Array.isArray(item.classNames) &&
        item.classNames.map(i => s[i]).join(' ')
      }
    >
      <div className="slick_UI smallArrow smallArrowBlack dark_theme">
        <Slider {...settings}>
          {item.items &&
            Array.isArray(item.items) &&
            item.items.map(
              it =>
                it?.hl && (
                  <ErrorBoundary>
                    <NewStoryCard msid={it?.hl} wu={it?.wu} width={2000} />
                  </ErrorBoundary>
                ),
            )}
        </Slider>
      </div>
    </div>
  );
};

export default BannerView;
